import styles from "./ReceiptMatchingMessage.module.scss";

export const ReceiptMatchingMessage = () => (
    <div>
        <div className="mb-2">
            Add your phone number to turn on receipt matching and keep your
            books audit-ready.
        </div>
        <ol className={styles.orderedList}>
            <li>Save the number that texts you as Kick.</li>
            <li>Snap a photo of any business receipt.</li>
            <li>Text it to Kick and we’ll match it automatically.</li>
        </ol>
        <div className={styles.previewContainer}>
            <img
                src="/images/receipts/previewWhite.png"
                alt="Receipt matching preview"
                className={styles.preview}
            />
        </div>
    </div>
);
